import Vue from 'vue'
import Router from 'vue-router'
import general from './general'
import store from '../store/index'

Vue.use(Router)
// 路由集合
let routers = []
//
/**
 * general 公共部分
 */
routers = routers.concat(general)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

let router = new Router({
  mode: 'history',
  base: '/web/',
  routes: routers
})

// 需要登录的页面直接拦截至登录页
router.beforeEach((to, from, next) => {
  if (!store.state.Auth.token && to.meta.isAuth) {
    next({name: 'Login'})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js